{
  "achievementCenter": "Başarı Merkezi",
  "achievementCenterSubtitle": "Rozetlerin kilidini açın, XP kazanın, seviyenizi yükseltin ve Exalt Exchange kimliğinizi oluşturun.",
  "badges": "Rozetler",
  "bearish": "Düşüş",
  "bullish": "Yükseliş",
  "buy": "Al",
  "comment": "Yorum Yap",
  "commentAddedSuccessfully": "Yorum başarıyla eklendi.",
  "commentFailed": "Yorum eklenemedi.",
  "communityFeed": "Topluluk Akışı",
  "communityPosts": "Topluluk Gönderileri",
  "completedTrades": "Tamamlanan İşlemler",
  "copyCode": "Kodu Kopyala",
  "copyLink": "Bağlantıyı Kopyala",
  "createSignalPost": "Sinyal / Piyasa Gönderisi Oluştur",
  "currentLevel": "Mevcut Seviye",
  "displayName": "Görünen Ad",
  "disputes": "İtirazlar",
  "exaltTrader": "EXALT Yatırımcısı",
  "failedCreatePost": "Gönderi oluşturulamadı.",
  "failedLoadAchievements": "Başarılar yüklenemedi.",
  "failedLoadReputation": "İtibar yüklenemedi.",
  "failedLoadSocialTrading": "Sosyal Alım Satım yüklenemedi.",
  "failedRefreshAchievements": "Başarılar yenilenemedi.",
  "failedRefreshReputation": "İtibar yenilenemedi.",
  "follow": "Takip Et",
  "followFailed": "Takip durumu güncellenemedi.",
  "followers": "Takipçiler",
  "following": "Takip Edilenler",
  "fraudFlags": "Dolandırıcılık İşaretleri",
  "goldBadges": "Altın Rozetler",
  "joinExaltUsingReferral": "Referans kodumu kullanarak Exalt Exchange'e katılın ve işlem yapmaya başlayın.",
  "joined": "Katılma Tarihi",
  "levelProgress": "Seviye İlerlemesi",
  "levelProgressText": "Bir sonraki seviyeye ulaşmak için XP kazanmaya devam edin.",
  "like": "Beğen",
  "likeFailed": "Beğeni güncellenemedi.",
  "loading": "Yükleniyor...",
  "loadingAchievementCenter": "Başarı Merkezi yükleniyor...",
  "loadingQr": "QR kodu yükleniyor...",
  "loadingReputationCenter": "İtibar Merkezi yükleniyor...",
  "loadingSocialTrading": "Sosyal Alım Satım yükleniyor...",
  "locked": "Kilitli",
  "low": "Düşük",
  "myTraderProfile": "Yatırımcı Profilim",
  "neutral": "Nötr",
  "noAchievementProfileFound": "Başarı profili bulunamadı.",
  "noBadgesYet": "Henüz rozet yok.",
  "noPostsYet": "Henüz gönderi yok.",
  "noReferralRewardsYet": "Henüz referans ödülü yok.",
  "noReferredMembersYet": "Henüz kimseyi davet etmediniz.",
  "noReputationHistoryYet": "Henüz itibar geçmişi yok.",
  "noReputationProfileFound": "İtibar profili bulunamadı.",
  "noTraders": "Yatırımcı bulunamadı.",
  "noTradersFound": "Yatırımcı bulunamadı.",
  "p2pOrders": "P2P Emirleri",
  "p2pRating": "P2P Puanı",
  "pair": "Parite",
  "platinum": "Platin",
  "postCreatedSuccessfully": "Gönderi başarıyla oluşturuldu.",
  "posting": "Yayınlanıyor...",
  "previous": "Önceki",
  "profitLoss": "Kâr / Zarar",
  "publishPost": "Gönderiyi Yayınla",
  "referralCodeCopied": "Referans kodu kopyalandı.",
  "referralLinkCopied": "Referans bağlantısı kopyalandı.",
  "referralLoadFailed": "Referans verileri yüklenemedi.",
  "referralQrCode": "Referans QR Kodu",
  "referralReward": "Referans Ödülü",
  "referralRewardHistory": "Referans Ödül Geçmişi",
  "referredUser": "Yönlendirilen Kullanıcı",
  "refreshAchievements": "Başarıları Yenile",
  "refreshScore": "Puanı Yenile",
  "reputationCenter": "Topluluk İtibarı",
  "reputationCenterSubtitle": "Alım satım güveni, P2P başarısı, doğrulanmış rozetler ve topluluk etkinliği ile EXALT kimliğinizi oluşturun.",
  "reputationHistory": "İtibar Geçmişi",
  "reputationScore": "İtibar Puanı",
  "searchYourMembers": "Üyelerinizi isim veya e-posta ile arayın",
  "sell": "Sat",
  "send": "Gönder",
  "sentiment": "Piyasa Duygusu",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "shareMarketViewPlaceholder": "Bir piyasa görüşü, işlem kurulumu, EXALT güncellemesi veya sinyal paylaşın...",
  "shareReferralLink": "Referans Bağlantısını Paylaş",
  "signal": "Sinyal",
  "socialTradingSubtitle": "Uzman yatırımcıları takip edin, piyasa fikirlerini paylaşın, sinyalleri görüntüleyin ve EXALT alım satım topluluğu ile birlikte büyüyün.",
  "socialTradingTitle": "Sosyal Alım Satım",
  "topTraders": "En İyi Yatırımcılar",
  "topTradersLeaderboard": "En İyi Yatırımcılar Liderlik Tablosu",
  "totalComments": "Toplam Yorum",
  "totalEarnings": "Toplam Kazanç",
  "totalLikes": "Toplam Beğeni",
  "totalReferrals": "Toplam Referans",
  "totalTraders": "Toplam Yatırımcı",
  "totalXp": "Toplam XP",
  "tradeType": "İşlem Türü",
  "tradingSuccess": "İşlem Başarısı",
  "unfollow": "Takibi Bırak",
  "unlocked": "Kilidi Açık",
  "username": "Kullanıcı Adı",
  "verified": "Doğrulandı",
  "winRate": "Kazanma Oranı",
  "writeBeforePosting": "Lütfen paylaşmadan önce bir şeyler yazın.",
  "writeComment": "Bir yorum yazın...",
  "yourReferralCode": "Referans Kodunuz",
  "yourReferralLink": "Referans Bağlantınız",
  "yourReferredMembers": "Davet Ettiğiniz Üyeler"
}